import React, { useCallback } from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';

import {
  COURSE_PAUSE_REQUEST_TRACKINGS,
  REQUEST_DATE_SORT_LABELS,
  REQUEST_DURATION_SORT_LABELS,
  setSortRequestField,
  setSortRequestType,
  sortRequestTypeSelector,
  sortRequestFieldSelector,
} from 'features/courseResume';
import analytics from 'utils/analytics';
import SortableTableCell from 'components/SortableTableCell';
import styles from './CoursePauseScheduledTableHeader.module.scss';
import TableCell from 'components/TableCell';
import TableHead from 'components/TableHead';
import TableRow from 'components/TableRow';

function CoursePauseScheduledTableHeader() {
  const dispatch = useDispatch();
  const sortValue = useSelector(sortRequestTypeSelector);
  const sortField = useSelector(sortRequestFieldSelector);

  const onSortChange = useCallback(
    (field, value) => {
      analytics.click({
        click_type: COURSE_PAUSE_REQUEST_TRACKINGS.coursePauseRequestSort,
        custom: {
          sort_order: value || 'reset',
          sort_field: field || sortField,
        },
      });
      batch(() => {
        dispatch(setSortRequestType(value));
        dispatch(setSortRequestField(field));
      });
    },
    [dispatch, sortField]
  );

  return (
    <>
      <TableHead className={styles.root}>
        <TableRow>
          <TableCell className={styles.heading}>Learner Info</TableCell>
          <TableCell className={styles.heading}>Pause from</TableCell>
          <SortableTableCell
            field="duration_of_pause"
            ascLabel={REQUEST_DURATION_SORT_LABELS.ascLabel}
            descLabel={REQUEST_DURATION_SORT_LABELS.descLabel}
            onSortChange={onSortChange}
            sortValue={sortValue}
            sortField={sortField}
          >
            Duration
          </SortableTableCell>
          <TableCell className={styles.heading}>New Super Batch</TableCell>
          <SortableTableCell
            field="scheduled_resume_date"
            ascLabel={REQUEST_DATE_SORT_LABELS.ascLabel}
            descLabel={REQUEST_DATE_SORT_LABELS.descLabel}
            onSortChange={onSortChange}
            sortValue={sortValue}
            sortField={sortField}
          >
            Scheduled Date
          </SortableTableCell>
          <TableCell className={styles.heading}>Note</TableCell>
          <TableCell className={styles.heading}>Action</TableCell>
        </TableRow>
      </TableHead>
    </>
  );
}

export default CoursePauseScheduledTableHeader;
